<template>
    <div class="row">
        <div class="mb-2 col-12">
            <div class="m-userStores__contactHeader">Numer telefonu:</div>
            {{ data.address.phone | formatPhone }}
        </div>
        <div class="mb-2 col-12">
            <div class="m-userStores__contactHeader">E-mail:</div>
            {{ data.address.email || '-' }}
        </div>
        <div class="mb-2 col-12">
            <div class="m-userStores__contactHeader">
                Media społecznościowe:
            </div>
            <store-social-media
                v-if="this.isSocialMediaLink"
                :data="data"
                :linkFields="linkFields"
            />
            <div v-else>-</div>
        </div>
    </div>
</template>

<script>
import StoreSocialMedia from '@/components/settings/userStores/StoreSocialMedia'

export default {
    props: {
        data: {
            type: Object,
            required: false
        },
        linkFields: {
            type: Array,
            required: true
        }
    },
    components: {
        StoreSocialMedia
    },
    computed: {
        isSocialMediaLink() {
            const data = this.data
            return (
                data.link_to_facebook ||
                data.link_to_instagram ||
                data.link_to_youtube ||
                data.link_to_website
            )
        }
    }
}
</script>
